import * as React from "react"
import { connect } from "react-redux"

import { Action } from "@tenforce/toolbox-button-push-react"
import { Symbols } from "@tenforce/toolbox-fontmap"

import { formatString } from "../../../../../util/Strings"

import { DispatchProps, mapDispatchToProps } from "../../../actions"
import { GlobalState } from "../../../../../store"
import { Labels } from "../../../../../util/Translations"
import { IPagination } from "../../../index"

interface OwnProps {
    totalNumberOfTerms: number
}

interface StateProps {
    pagination: IPagination
}

type Props = OwnProps & StateProps & DispatchProps

const LoadMore = ({
    loadMoreTerms,
    totalNumberOfTerms,
    pagination: { page, size },
}: Props): JSX.Element => {
    const numberOfLoaded = page * size

    if (totalNumberOfTerms <= numberOfLoaded) {
        return <></>
    }

    const { LoadNMoreOf } = Labels

    const numberOfNotLoaded = totalNumberOfTerms - numberOfLoaded
    const nextPageSize = numberOfNotLoaded > size ? size : numberOfNotLoaded

    const loadMoreLabel = formatString(
        LoadNMoreOf,
        nextPageSize,
        numberOfNotLoaded,
    )

    return (
        <Action
            extraClasses="theme-thumb theme-thumb--wide theme-note"
            onClick={loadMoreTerms}
            id="dictionaryLoadMore"
        >
            {`${Symbols.Cards} ${loadMoreLabel}`}
        </Action>
    )
}

const mapStateToProps = (state: GlobalState): StateProps => ({
    pagination: state.contextualHelp.dictionaryPopup.termsPagination,
})

export default connect(mapStateToProps, mapDispatchToProps)(LoadMore)
